import { render, staticRenderFns } from "./Signout.Detail.vue?vue&type=template&id=22a2b7ee&"
import script from "./Signout.Detail.vue?vue&type=script&lang=js&"
export * from "./Signout.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports